

































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { addClass, removeClass, hasClass } from '@/utils/jsHelpers';

import { Policy, PolicyUi } from '@/common/Policy';
import { PaymentSources, PaymentHistory as PH, PaymentHistoryMethod, PaymentHistoryStatus } from '@/common/Payments';

import Brand from '@/services/Brand';

import Welcome from '@/components/Global/Welcome.vue';
import Loading from '@/components/Global/Loading.vue';
import Card from '@/components/Global/Card.vue';
import PolicySelector from '@/components/Global/PolicySelector.vue';
import AccordionItem from '@/components/Global/Accordion/AccordionItem.vue';
import { INotification } from '../../components/Global/Notification.vue';
import { getSettings } from '@/services/Settings';
import BillPayService from '@/services/BillPay';
import PaymentHistory from '@/components/Payment/PayBill/History.vue';
import TermsConditions from '@/components/Payment/PayBill/TermsConditions.vue';
import verifyPaymentMethod from '@/components/Payment/Methods/VerifyPaymentMethod.vue';

import { createDateComparer } from '@/utils/Sorting';
import { Source, PaymentObject } from '@/common/BillPay';
import moment from 'moment';

import jQuery from 'jquery';

@Component({
	name: 'BillPay2.0',
	components: {
		Card,
		Welcome,
		Loading,
		PolicySelector,
		AccordionItem,
		PaymentHistory,
		TermsConditions,
		verifyPaymentMethod,
	},
})
export default class BillPay extends Vue {
	@Getter('activePolicies', { namespace: 'Policy' }) private policies: PolicyUi[];
	@Getter('getPolicyById', { namespace: 'Policy' }) private getPolicyById: (
		policy_number: string,
	) => Policy;
	@Action('getRecurringPolicies', { namespace: 'Payment' })
	private getRecurringPolicies: () => void;
	@Getter('payment_sources', { namespace: 'Payment' }) private paymentSources: PaymentSources[];
	@Action('setPaymentSources', { namespace: 'Payment' }) private setPaymentSources: () => void;
	@Getter('recurring_payment', { namespace: 'Payment' }) private recurringPayments: any;

	private loading: boolean = true;
	private loadingBalance: boolean = false;
	private changePolicy: string = '';
	private currentStep: number = 0;
	private other_amount: string = '0';
	private payment_amount: string = 'due';
	private payment_method: string = '';
	private authorizedToSubmt: boolean = false;
	private paymentSubmissionLoading: boolean = false;
	private paymentSubmissionStatus: boolean | string = false;
	private paymentHistory: PH[] = [];

	private Brand: any = Brand;

	private payment_enabled: { setting_key: string; visible: boolean } = {
		setting_key: 'payment_enabled',
		visible: true,
	};
	private paymentDowntimeMessage: { setting_key: string; message: string } = {
		setting_key: 'payment_message',
		message: '',
	};

	@Watch( 'changePolicy' )
	private watchChangePolicy() {
		this.resetPayment( false );
	}

	private resetPayment( policyNumber = true ) {
		if ( policyNumber ) {
			this.changePolicy = '';
		}

		this.loading = true;
		this.currentStep = 0;
		this.other_amount = '0';
		this.payment_amount = 'due';
		this.payment_method = '';
		this.authorizedToSubmt = false;
		this.paymentSubmissionLoading = false;
		this.paymentSubmissionStatus = false;
		this.loading = false;
	}

	private async created() {
		try {
			const [, , getOnlineSetting] = await Promise.all([
				this.setPaymentSources(),
				this.getRecurringPolicies(),
				getSettings(['payment_enabled', 'payment_message']),
			]);
			this.payment_enabled = getOnlineSetting.data.find(
				s => s.setting_key === 'payment_enabled',
			);
			this.paymentDowntimeMessage = getOnlineSetting.data.find(
				s => s.setting_key === 'payment_message',
			);

			this.loading = false;
		} catch (e) {
			this.loading = false;
		}
	}

	get getPolicy(): Policy | null {
		if (this.changePolicy) {
			this.currentStep = 1;
			const policy = this.getPolicyById(this.changePolicy);
			// Only way to get an async call inside a getter/computed property
			const getBalance = async () => {
				this.loadingBalance = true;
				const getBalanceData = await BillPayService.getBalanceData(policy.product_id);

				policy.balance = getBalanceData;
				this.paymentHistory = policy.balance?.payment_history;
				this.loadingBalance = false;
			};
			getBalance();
			return policy;
		}

		this.currentStep = 0;
		return null;
	}

	get todaysDate() {
		const today = new Date();
		const dd = String(today.getDate()).padStart(2, '0');
		const mm = String(today.getMonth() + 1).padStart(2, '0');
		const yyyy = today.getFullYear();

		return mm + '/' + dd + '/' + yyyy;
	}

	private stepClass(step: number): string {
		let classList = '';
		if (this.currentStep !== step) {
			classList = 'inactive';
		}

		if (this.currentStep === step) {
			classList = 'active';
		}

		if (this.currentStep > step) {
			classList = 'completed';
		}

		return classList;
	}

	get step1Validation(): boolean {
		if (this.getPolicy === null) {
			return false;
		}

		if (this.payment_amount === 'other') {
			return Number(this.other_amount) !== 0;
		}

		if (this.getPolicy.balance[this.payment_amount] <= 0) {
			return false;
		}

		return this.payment_amount !== '';
	}

	get step2Validation(): boolean {
		if (!this.step1Validation) {
			return false;
		}

		if (this.paymentMethod === null) {
			return false;
		}

		if (this.paymentMethod.type === 'card' && this.paymentAmount >= 50000) {
			return false;
		}

		return true;
	}

	get step3Validation(): boolean {
		if (!this.step2Validation) {
			return false;
		}

		return this.authorizedToSubmt;
	}

	get paymentAmount(): number {
		if (this.getPolicy === null) {
			return 0;
		}

		if (this.payment_amount === 'other') {
			return parseFloat(this.other_amount);
		}

		if (this.getPolicy.balance[this.payment_amount] <= 0) {
			return 0;
		}

		return this.getPolicy.balance[this.payment_amount];
	}

	get paymentMethod(): PaymentSources {
		return this.paymentSources.find(source => source.id === this.payment_method) || null;
	}

	get recurringPayment(): any {
		return (
			this.recurringPayments.find(payment => payment.policy_num === this.changePolicy) || null
		);
	}

	private nextStep(step) {
		this.currentStep = step;
	}

	/**
	 * Split payment into multiple pieces if over 1 mil
	 * Make the payment to our Stripe lambda backend.
	 */
	private async makePayment() {
		const paymentAmount = [];

		if (this.paymentAmount >= 1000000) {
			paymentAmount.push(750000);
			paymentAmount.push(this.paymentAmount - 750000);
		} else {
			paymentAmount.push(this.paymentAmount);
		}

		try {
			this.paymentSubmissionLoading = true;
			await Promise.all(
				paymentAmount.map(async (amount: number) => {
					const paymentObjectParams: PaymentObject = {
						type: this.paymentMethod.type,
						token: this.paymentMethod.id,
						policy_num: this.getPolicy.policy_number,
						// @ts-ignore
						payer: this.paymentMethod.account_holder_name,
						agree_to_terms: true,
						amount,
					};
					const submitPayment = await BillPayService.submitPayment(paymentObjectParams);

					if (
						submitPayment.data?.failure_code &&
						submitPayment.data?.failure_code !== 'none'
					) {
						throw new Error(submitPayment.data.failure_code);
					}

					const policy = this.getPolicyById(this.changePolicy);
					const getBalanceData = await BillPayService.getBalanceData(policy.product_id);
					// this.paymentHistory.push( {
					// 	amount: '$' + this.paymentAmount,
					// 	date: moment(new Date().toString()).format('MM/DD/YYYY HH:mm'),
					// 	last_4: this.paymentMethod?.last4,
					// 	method: this.paymentMethod.type.toUpperCase() as PaymentHistoryMethod,
					// 	payer: this.paymentMethod?.account_holder_name,
					// 	status: 'PENDING' as PaymentHistoryStatus,
					// } );
				}),
			);

			this.paymentSubmissionLoading = false;
			this.paymentSubmissionStatus = true;
		} catch (e) {
			this.paymentSubmissionLoading = false;
			this.paymentSubmissionStatus = e.toString();
		}
	}

	private showAddress() {
		const address = document.querySelector('.address');
		if (hasClass(address, 'closed')) {
			removeClass(address, 'closed');
		} else {
			addClass(address, 'closed');
		}
	}

	private scrollToPaymentHistory(e) {
		const paymentHistory = jQuery('.payment_history');
		window.scrollTo(0, paymentHistory.position().top);
	}
}
